import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { connect } from "react-redux";
import { ButtonCompo } from "../../../components/Comman/Button";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import claimManagementStyles from "../../../Styles/claimManagement";
import React from "react";

const LeaveStructureDetailsTable = ({
    dataList,
    clickSubmitHandler,
    onChangeRadioGroup,
    onChangeTextField,
    formErrorForDetails,
    isShowExtraFieldAtLeaveStructure,
}) => {

    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const getFilteredTableData = (tableData) => {
        return tableData.filter((currentRow) => {

            let isValid = false;
            let name =
                currentRow.name != null ? currentRow.name : "";
            let allotedLeaves =
                currentRow.allotedLeaves != null ? currentRow.allotedLeaves : "";
            let minimumDaysPerLeave =
                currentRow.minimumDaysPerLeave != null ? currentRow.minimumDaysPerLeave : "";
            let maximumDaysPerLeave =
                currentRow.maximumDaysPerLeave != null ? currentRow.maximumDaysPerLeave : "";
            let maximumCarryForwardDays =
                currentRow.maximumCarryForwardDays != null ? currentRow.maximumCarryForwardDays : "";

            if (
                name &&
                name.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                allotedLeaves &&
                allotedLeaves.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                minimumDaysPerLeave &&
                minimumDaysPerLeave.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                maximumDaysPerLeave &&
                maximumDaysPerLeave.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                maximumCarryForwardDays &&
                maximumCarryForwardDays.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    return (
        <>
            <LandingScreenHeader
                screenTitle={""}
                showSearchBox={true}
                showTable={true}
                showFilter={false}
                showPdfDownload={false}
                showExcelDownload={false}
                onSearch={onSearchValue}
            />

            <div
                style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "500px",
                    position: "relative",
                }}
            >
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    <thead
                        style={{
                            position: "sticky",
                            top: 0,
                            background: "#03a9f4",
                            zIndex: 3,
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <tr>

                            <th
                                style={{
                                    ...claimManagementStyles.tableHeadStyle,
                                    minWidth: "70px",
                                }}
                            >
                                Sr. No
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "230px", }}>
                                Leave Title
                            </th>

                            <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "100px", }}>
                                No.Of Leaves
                            </th>

                            {isShowExtraFieldAtLeaveStructure == 1 && (
                                <>
                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "120px", }}>
                                        Minimum Days Per Leave
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "120px", }}>
                                        Maximum Days Per Leave
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "130px", }}>
                                        Maximum Carry Forward Days
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "140px", }}>
                                        Can Be Encashed?
                                    </th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {getFilteredTableData(dataList).map((dataObj, index) => (
                            <tr key={dataObj.id}>
                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "center",
                                    }}
                                >
                                    {dataObj.index !== null ? dataObj.index : ""}
                                </td>
                                <td
                                    style={{
                                        ...claimManagementStyles.cellStyle,
                                        textAlign: "left",
                                    }}
                                >
                                    {dataObj.name !== null ? dataObj.name : ""}
                                </td>

                                <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                        <input
                                            type="number"
                                            name={"allotedLeaves"}
                                            value={dataObj.allotedLeaves}
                                            min="0"
                                            onChange={(e) => onChangeTextField(e, dataObj.id)}
                                            onKeyDown={(e) => {
                                                if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            style={{
                                                width: "150px",
                                                padding: "4px 6px",
                                                fontSize: "14px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                textAlign: "center",
                                            }}
                                        />
                                    </div>
                                    {formErrorForDetails?.[`allotedLeavesError${dataObj.id}`] && (
                                        <div style={{ color: "red", fontSize: 12, textAlign: "center", marginTop: 4 }}>
                                            {formErrorForDetails[`allotedLeavesError${dataObj.id}`]}
                                        </div>
                                    )}
                                </td>

                                {isShowExtraFieldAtLeaveStructure == 1 && (
                                    <>
                                        <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                <input
                                                    type="number"
                                                    name={"minimumDaysPerLeave"}
                                                    value={dataObj.minimumDaysPerLeave}
                                                    min="0"
                                                    onChange={(e) => onChangeTextField(e, dataObj.id)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    style={{
                                                        width: "150px",
                                                        padding: "4px 6px",
                                                        fontSize: "14px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        textAlign: "center",
                                                    }}
                                                />
                                            </div>
                                            {formErrorForDetails?.[`minimumDaysPerLeaveError${dataObj.id}`] && (
                                                <div style={{ color: "red", fontSize: 12, textAlign: "center", marginTop: 4 }}>
                                                    {formErrorForDetails[`minimumDaysPerLeaveError${dataObj.id}`]}
                                                </div>
                                            )}
                                        </td>

                                        <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                <input
                                                    type="number"
                                                    name={"maximumDaysPerLeave"}
                                                    min="0"
                                                    value={dataObj.maximumDaysPerLeave}
                                                    onChange={(e) => onChangeTextField(e, dataObj.id)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    style={{
                                                        width: "150px",
                                                        padding: "4px 6px",
                                                        fontSize: "14px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        textAlign: "center",
                                                    }}
                                                />
                                            </div>
                                            {formErrorForDetails?.[`maximumDaysPerLeaveError${dataObj.id}`] && (
                                                <div style={{ color: "red", fontSize: 12, textAlign: "center", marginTop: 4 }}>
                                                    {formErrorForDetails[`maximumDaysPerLeaveError${dataObj.id}`]}
                                                </div>
                                            )}
                                        </td>

                                        <td style={{ ...claimManagementStyles.cellStyle, textAlign: "right" }}>
                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                <input
                                                    type="number"
                                                    name={"maximumCarryForwardDays"}
                                                    min="0"
                                                    value={dataObj.maximumCarryForwardDays}
                                                    onChange={(e) => onChangeTextField(e, dataObj.id)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    style={{
                                                        width: "150px",
                                                        padding: "4px 6px",
                                                        fontSize: "14px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        textAlign: "center",
                                                    }}
                                                />
                                            </div>
                                            {formErrorForDetails?.[`maximumCarryForwardDaysError${dataObj.id}`] && (
                                                <div style={{ color: "red", fontSize: 12, textAlign: "center", marginTop: 4 }}>
                                                    {formErrorForDetails[`maximumCarryForwardDaysError${dataObj.id}`]}
                                                </div>
                                            )}
                                        </td>

                                        <td style={{ ...claimManagementStyles.cellStyle, textAlign: "center" }}>
                                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                                <RadioGroup
                                                    row
                                                    value={dataObj.canBeEncashed}
                                                    onChange={(e) => onChangeRadioGroup(e, dataObj.id)}
                                                >
                                                    <FormControlLabel value={1} control={<Radio size="small" />} label="Yes" />
                                                    <FormControlLabel value={0} control={<Radio size="small" />} label="No" />
                                                </RadioGroup>
                                            </div>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div >

            <br />
            <Grid
                item
                sm={12}
                xs={12}
                md={12}
                lg={12}
                container
                justifyContent="flex-end"
                gap={2}
            >
                <ButtonCompo
                    sx={{
                        bgcolor: "dodgerblue",
                        color: "#fbff00",
                    }}
                    size="medium"
                    type="button"
                    variant="contained"
                    name={"Submit"}
                    onClick={clickSubmitHandler}
                    fullWidth={false}
                />
            </Grid>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeaveStructureDetailsTable);
